import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { GeneralApiService, StatusApi } from '../api';

const LOCAL_STORAGE_KEY = 'EmpresaCentralizadaService.empresaSeleccionadaIdId';

export enum MODULOS_ENLAZADOS {
  FORMAS_DE_PAGO = '16',
  PROVEEDORES = '14',
  BONIFICACIONES = '72',
  TIPOS_DE_VENTA = '71'
}

export interface IModuloEnlazado {
  id: string,
  empresa: string,
  nombre: MODULOS_ENLAZADOS
}
export interface IResponseCentralizada {
  subdominio: string,
  enlazada: boolean,
  centralizada: boolean,
  modulosEnlazados: IModuloEnlazado[]
}
@Injectable({
  providedIn: 'root',
})
export class EmpresaCentralizadaService {
  /**
   * Undefined si no se ha recibido la información del servidor.
   * Null si ha habido algún error al recibir la información del servidor.
   * Boolean si se ha recibido la información del servidor.
   */
  private readonly esEmpresaCentralizada = new BehaviorSubject<boolean | null>(null);
  private readonly modulosEnlazados = new BehaviorSubject<IModuloEnlazado[] | null>(null);

  set empresaSeleccionadaId(empresaId: string) {
    localStorage.setItem(LOCAL_STORAGE_KEY, empresaId);
  }
  get empresaSeleccionadaId() {
    return localStorage.getItem(LOCAL_STORAGE_KEY);
  }
  apiStatusEmpresaCentralizada = new StatusApi();
  constructor(private readonly generalApiService: GeneralApiService) {}
  /**
   *
   * @returns Devuelve un observable para comprobar si la empresa en la que estamos es centralizada o no. Puede ser null si no se ha recibido la información del servidor.
   */
  $esEmpresaCentralizada() {
    return this.esEmpresaCentralizada.asObservable();
  }
  $modulosEnlazados() {
    return this.modulosEnlazados.asObservable();
  }
  /**
   * Puede que no se haya recibido la información del servidor y tengamos que volver a entrar en la página donde se incluya, ya que no se trata de un observable.
   * @returns Devuelve el valor actual de si la empresa en la que estamos es centralizada o no. Puede ser null si no se ha recibido la información del servidor.
   */
  get esEmpresaCentralizadaValue() {
    return this.esEmpresaCentralizada.value;
  }

  get modulosEnlazadosValue() {
    return this.modulosEnlazados.value;
  }
  setEmpresaSeleccionadaId(empresaId: string) {
    this.empresaSeleccionadaId = empresaId;
    this.esEmpresaCentralizada.next(null);
    this.modulosEnlazados.next(null);
  }
  async obtenerEsEmpresaCentralizada() {
    if (this.esEmpresaCentralizada.value === null && !this.apiStatusEmpresaCentralizada.isLoading()) {
      const { centralizada, modulosEnlazados } = await this.generalApiService.callApi<IResponseCentralizada>('get', `/empresa/${this.empresaSeleccionadaId}`, {
        loading: this.apiStatusEmpresaCentralizada,
        keyResult: null,
      });
      this.esEmpresaCentralizada.next(centralizada);
      this.modulosEnlazados.next(modulosEnlazados);
    }
  }
}
